import { cn } from "@/lib/utils";

export function EliteCard({
    className,
    children,
}: {
    className?: string;
    children: React.ReactNode;
}) {
    return (
        <div
            className={cn(
                "bg-bg-surface border border-white/5 shadow-[0_10px_30px_rgba(0,0,0,0.6)]",
                "backdrop-blur-sm",
                "transition-all duration-200",
                "hover:border-gold-500/20 hover:shadow-[0_16px_44px_rgba(0,0,0,0.75)]",
                className
            )}
        >
            {children}
        </div>
    );
}
